<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Elementos multimedia</h1>
      </div>
    </div>
    <div class="content__row">
      <div class="content__column content__column--wide">
        <media-files></media-files>
      </div>
    </div>
  </div>
</template>

<script>
import mediaFiles from './files'
export default {
  components: {mediaFiles}
}
</script>

<style lang="sass">
@import "../../assets/sass/components/_home"
@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/media/view.vue